var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-payment-confirm-page"},[_c('signup-payment-confirm-pane',{on:{"handlerSubmit":_vm.moveToSignupComplete,"handlerCancel":_vm.handlerCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }